module.exports = __webpack_public_path__ + "img/DefaultUser.c0d3dc8d.png";